var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form__row"},[_vm._l((_vm.slots),function(slot){return _vm._t(slot)})],2)}
var staticRenderFns = []

export { render, staticRenderFns }